const _excluded = ["job"];
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from 'react';
import { v4 as uuidV4 } from 'uuid';
import PropTypes from 'prop-types';
import moment from 'moment';
import { viewPermissionSelector, editPermissionSelector } from '../../../common/classes/permissions';
import entityComposition from '../../../common/classes/entityComposition';
const onJobAdd = (props, contentPath, defaults) => {
  const {
    userID,
    job: {
      active
    },
    jobActions: {
      change
    }
  } = props;
  const {
    id
  } = active;
  const listItem = _objectSpread({
    id: uuidV4().toUpperCase(),
    appCreated: moment().utc().format('YYYY-MM-DD HH:mm:ss'),
    appCreatorID: userID
  }, defaults);
  // Find reference to list
  const subPaths = contentPath.split('/');
  let ref = active;
  subPaths.forEach(subPath => {
    ref = ref[subPath];
  });
  // Add item to list
  ref.push(listItem);
  change(id, contentPath, ref);
};
const onJobRemove = (props, contentPath, removeIndex) => {
  // console.log(`removing ${JSON.stringify(props)}`);
  const {
    job: {
      active
    },
    jobActions: {
      change
    }
  } = props;
  const {
    id
  } = active;
  // Find reference to list
  const subPaths = contentPath.split('/');
  let ref = JSON.parse(JSON.stringify(active));
  subPaths.forEach(subPath => {
    ref = ref[subPath];
  });
  ref.splice(parseInt(removeIndex, 10), 1);
  change(id, subPaths.join('/'), ref);
};
const onJobChangeEvent = (props, contentPath, value) => {
  const {
    job: {
      active
    },
    jobActions: {
      change
    }
  } = props;
  const {
    id
  } = active;
  // Decorate the change event with the job ID
  change(id, contentPath, value);
};
const wrapJobActions = Component => {
  const WrappedComponent = _ref => {
    let {
        job = {
          active: {}
        }
      } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded);
    const {
      active
    } = job;
    const bindHandleAdd = (contentPath, defaults) => {
      onJobAdd(_objectSpread({
        job
      }, otherProps), contentPath, defaults);
    };
    const bindHandleRemove = (contentPath, removeIndex) => {
      onJobRemove(_objectSpread({
        job
      }, otherProps), contentPath, removeIndex);
    };
    const bindHandleChangeEvent = (contentPath, value) => {
      onJobChangeEvent(_objectSpread({
        job
      }, otherProps), contentPath, value);
    };
    return /*#__PURE__*/React.createElement(Component, _objectSpread({
      onJobAdd: bindHandleAdd,
      onJobRemove: bindHandleRemove,
      onJobChange: bindHandleChangeEvent,
      active: active,
      job: job
    }, otherProps));
  };
  WrappedComponent.propTypes = {
    job: PropTypes.shape({
      active: PropTypes.shape({})
    }),
    canEdit: PropTypes.bool.isRequired,
    canView: PropTypes.bool.isRequired,
    userID: PropTypes.string.isRequired
  };
  return WrappedComponent;
};
const withJobActions = Component => entityComposition(wrapJobActions(Component), ['job', 'jobPiece'], {
  canView: state => viewPermissionSelector('job')(state),
  canEdit: state => editPermissionSelector('job')(state),
  userID: state => state.login.user.user_id,
  activeJob: state => state.job.active
}, ['settings']);
export { wrapJobActions as testWithJobActions };
export default withJobActions;